module.exports = __webpack_public_path__ + "assets/03e198f3a6d3be41d5e342b0376cfd48.png";